// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__167Z-","paymentContainer":"PaymentPage_paymentContainer___Dpg5"};